function getStorageItem(key, fallback = '') {
  try {
    const value = localStorage.getItem(key)
    return value !== null ? value : fallback
  } catch (error) {
    return fallback
  }
}

function getStorageJSON(key, fallback) {
  const rawValue = getStorageItem(key, null)

  if (rawValue === null || rawValue === '') {
    return fallback
  }

  try {
    return JSON.parse(rawValue)
  } catch (error) {
    try {
      localStorage.setItem(key, JSON.stringify(fallback))
    } catch (storageError) {
      // Ignore storage recovery errors and return the fallback.
    }

    return fallback
  }
}

function setStorageItem(key, value) {
  try {
    if (value === null || typeof value === 'undefined') {
      localStorage.removeItem(key)
      return
    }

    localStorage.setItem(key, value)
  } catch (error) {
    // Ignore storage write errors to avoid breaking the UI.
  }
}

function setStorageJSON(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch (error) {
    // Ignore storage write errors to avoid breaking the UI.
  }
}

export {
  getStorageItem,
  getStorageJSON,
  setStorageItem,
  setStorageJSON,
}
